<template>
  <v-dialog :value="value" :fullscreen="$vuetify.breakpoint.smAndDown" max-width="1080" scrollable @input="$emit('input', $event)">
    <v-card class="invoice-preview-dialog">
      <v-card-title class="invoice-preview-dialog__header">
        <div><span>Invoice preview</span><small v-if="invoice">Invoice #{{ invoice.localId }}</small></div>
        <v-btn icon aria-label="Close invoice preview" @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="invoice-preview-dialog__body">
        <div v-if="loading" class="invoice-preview-dialog__loading"><v-progress-circular indeterminate color="primary" /><span>Loading invoice…</span></div>
        <iframe v-if="invoice" :key="invoice.id" :src="invoiceUrl" :title="`Invoice #${invoice.localId}`" @load="loading = false" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Hashids from "hashids";

const hashids = new Hashids();

export default {
  name: "InvoicePreviewDialog",
  props: {
    value: { type: Boolean, default: false },
    invoice: { type: Object, default: null },
  },
  data: () => ({ loading: false }),
  computed: {
    invoiceUrl() { return this.invoice ? `/global/invoice/${hashids.encode(this.invoice.id)}/view` : ""; },
  },
  watch: {
    value(open) { if (open) this.loading = true; },
    invoice(value) { if (value) this.loading = true; },
  },
};
</script>

<style scoped>
.invoice-preview-dialog{display:flex;flex-direction:column;height:min(900px,92vh)}
.invoice-preview-dialog__header{display:flex;justify-content:space-between;padding:14px 18px}
.invoice-preview-dialog__header div{display:flex;flex-direction:column}
.invoice-preview-dialog__header small{color:#718096;font-size:12px;font-weight:500}
.invoice-preview-dialog__body{position:relative;flex:1;min-height:0;padding:0!important;background:#f5f7f6}
.invoice-preview-dialog__body iframe{display:block;width:100%;height:100%;border:0;background:#fff}
.invoice-preview-dialog__loading{position:absolute;z-index:1;inset:0;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:12px;background:#f5f7f6;color:#718096}
@media(max-width:800px){.invoice-preview-dialog{height:100vh}}
</style>
